// extracted by mini-css-extract-plugin
module.exports = {"root":"hero_root__Sa-ft","outer":"hero_outer__3aJPb","inner":"hero_inner__1-Lve","heading":"hero_heading__3HM3Q"};